const newsletter = `
# eBL Newsletter 1

## 28 September 2020

### Conventions_Fragmentarium

#### Genres

- Genres are divided into four major groups: Archival, Canonical, Monumental, and
  Other. In the groups there are up to three levels of categorisation, e.g.
  CANONICAL > Literature > Monologue and Dialogue > Fables.
- To add a genre classification to a tablet simply select the appropriate option
  from the drop-down menu under “Genres”.
- It is possible to add several genre classifications to one tablet.
- If only the genre group that a text belongs to is known, just select one of
  the four groups from the drop-down menu.

#### Colophons

- Use @colophon to mark the section containing the colophon (after the ruling).
- Colophons should be added to the Colophon database
  ([here](https://gwi-fm1.gwi.uni-muenchen.de/fmi/webd), user name and password
  provided separately).

#### Image Annotation (Paleography)

- Tablets with interesting epigraphic features should be added to this list
  ([here](https://trello.com/c/fmxeDDGE)), so that they can be systematically
  tagged.

#### Intralinear Bilinguals

- Transliterate Sumerian and Akkadian each in their own line and differentiate
  the line number by appending a and b.
- Don’t use the language shift (e.g. %es) in these cases.
- [K.69](https://www.ebl.lmu.de/fragmentarium/K.69) o. 40 should be
  transliterated as:
  40a. %es [du₁₀-bad-ra₂-zu & a-ba ba]-ra-šub-ba#
  40b. ($___$) [...] & man-nu ip-pa-ra-aš₂-šid

#### Textcritical Glosses

- If the entry of a variant on a tablet doesn’t repeat the antecedent in full
  the respective word needs to be supplied, see e.g.
  [K.5308](https://www.ebl.lmu.de/fragmentarium/K.5308) o. 17:
  17´. %es i#-bi₂-bi er₂-ra : <(er₂)>-ta na-ma-an-<(bad-bad-da)> :
  nu-mu-un-bad-bad-da# [(x)]

### Conventions_Corpus

#### Hemistichic Layout (akk. _ṣullupu_)

- For Mss. that consequently indicate the caesura in the layout with a clear
  gap in the middle of each line use & at the respective place in the
  transliteration of the respective manuscript.`

export default newsletter
